// @ts-nocheck
import { TeamOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import { useCallback } from "react";
import Card from "../Card";
// @ts-ignore
import Table from "../Table";
import useRelatedChannels from "../../hooks/apis/useRelatedChannels";

const RelatedChannelsCard = () => {
  const { data } = useRelatedChannels();
  const relatedChannels = data?.data ?? [];
  const fetchFn = useCallback(async () => ({ data: relatedChannels }), [relatedChannels]);

  const abbreviateUrl = (url: string, maxLength = 25) => {
    if (!url || url.length <= maxLength) {
      return url;
    }
    const start = Math.floor(maxLength / 2) - 2;
    const end = url.length - Math.floor(maxLength / 2) + 2;
    return `${url.substring(0, start)}...${url.substring(end)}`;
  };

  const columns = [
    {
      title: "عنوان ",
      key: "title",
    },
    {
      key: "url",
      title: "آدرس",
      render: (value: string) => (
        <a href={value} target="_blank" rel="noopener noreferrer">
          {abbreviateUrl(value)}
        </a>
      ),
    },
    {
      key: "relationTitle",
      title: "نوع ارتباط",
      render: (value: string) => <Tag>{value}</Tag>,
    },
  ];

  // Don't clutter the page for users with no related channels
  if (!relatedChannels.length) {
    return null;
  }

  return (
    <Card title="کانال‌های مرتبط" Icon={TeamOutlined} className="flex-grow">
      <Table
        columns={columns}
        className="mt-4"
        fetchFn={fetchFn}
        rowKey="id"
        pagination={false}
      />
    </Card>
  );
};

export default RelatedChannelsCard;
